import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
/* ⚠ AS MESMAS DUAS FOTOS DO LOGIN (10/09/2026, escolha do dono do
   produto: "foto mesma do login").

   São duas porque o Login já resolveu isso em 07/09 com razão medida: no
   COMPUTADOR entra a parede de gabaritos, cujo detalhe se concentra a
   25-28% da largura — exatamente a faixa logo depois do painel. No
   CELULAR entra o prédio. Herdando as duas, a troca de senha ganha a
   decisão inteira de graça, e não só a imagem. */
import fotoPredio from '../../assets/fabrica-predio.jpg';
import fotoGabaritos from '../../assets/fabrica-gabaritos.jpg';

/**
 * Troca obrigatória de senha no primeiro acesso (13/08/2026).
 *
 * ACHADO QUE MOTIVOU ESTA TELA — a troca obrigatória JÁ EXISTIA, em
 * todas as pontas, e nunca funcionou:
 *
 *   · a coluna `primeiro_acesso` existe no banco, com DEFAULT TRUE;
 *   · o backend a marca TRUE ao resetar senha (adminController);
 *   · o login devolve `primeiroAcesso` no payload (authController);
 *   · o AuthContext tem `trocarSenha`, que limpa a flag.
 *
 * Só que NADA bloqueava. Não havia tela, guarda nem redirecionamento
 * olhando essa flag — ela só aparecia como pastilha informativa no
 * painel Admin, e `trocarSenha` era chamado de um único lugar: o modal
 * "Meu Perfil", voluntariamente.
 *
 * Consequências reais:
 *   1. todo usuário criado mantinha indefinidamente a senha que o
 *      Master escolheu pra ele — ou seja, o Master sabia a senha de
 *      todo mundo;
 *   2. a mensagem que o backend devolve ao resetar ("Usuário deverá
 *      trocar no próximo acesso") era FALSA — prometia algo que o
 *      sistema não fazia.
 *
 * O mecanismo foi construído nas duas pontas e o meio nunca foi feito.
 * Esta tela é o meio. Com ela funcionando, o Master escolher a senha
 * inicial deixa de ser problema: ela vira senha de uso único, válida
 * só até o primeiro login.
 *
 * Sem saída: não há botão de fechar nem link de voltar. A guarda está
 * na RotaProtegida (App.jsx), então qualquer rota logada cai aqui
 * enquanto a flag estiver de pé. Só "Sair" escapa.
 */
export default function TrocaObrigatoria() {
  const { usuario, trocarSenha, logout } = useAuth();
  /* ⚠ UM ESTADO POR CAMPO, e não um só para os três (10/09/2026).

     Decisão do dono do produto: "a senha sempre oculta, aparece se
     clicar no olho" — então o padrão é `false` nos três, e o `repetir`
     CONTINUA existindo. Ele só sairia se a senha ficasse visível por
     padrão, que era a outra saída oferecida e foi recusada.

     ⚠ E são três estados porque revelar um campo não deve revelar os
     outros: quem abre o olho da senha nova para conferir o que digitou
     não pediu para mostrar a senha do administrador na mesma tela. */
  const [verAtual, setVerAtual] = useState(false);
  const [verNova, setVerNova] = useState(false);
  const [verConfirma, setVerConfirma] = useState(false);
  /* Último passo da sequência, e ela é escura inteira — ver a nota no
     `Login.jsx`. A classe também fecha a faixa que o `zoom` da raiz
     deixa embaixo do `100vh`. */
  useEffect(() => {
    document.body.classList.add('tela-entrada');
    const anterior = document.documentElement.dataset.tema;
    document.documentElement.dataset.tema = 'dark';
    return () => {
      document.body.classList.remove('tela-entrada');
      if (anterior) document.documentElement.dataset.tema = anterior;
    };
  }, []);

  const [senhaAtual, setSenhaAtual] = useState('');
  const [nova, setNova] = useState('');
  const [confirma, setConfirma] = useState('');
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);

  const curta = nova.length > 0 && nova.length < 6;
  const diferentes = confirma.length > 0 && nova !== confirma;
  /* ⚠ ESTA CHECAGEM JÁ EXISTIA NA TELA, e eu quase a dupliquei
     (10/09/2026). Ao implementar a decisão "nunca pode ser igual à
     senha atual", escrevi a mesma linha 13 linhas abaixo — o build
     recusou com "igualAtual has already been declared".

     **Ler antes de escrever.** É a terceira vez em dois dias que eu
     acrescento o que já está lá: o `pv-medidas`, o `.fc-gcab-sub`, e
     agora esta.

     ⚠ O QUE DE FATO FALTAVA ERA A REGRA NO SERVIDOR. A tela bloqueava o
     botão; o `authController` aceitava. Quem chamasse a API por fora
     passava. Validação de tela é conforto — a regra vive no servidor, e
     ela foi escrita hoje. */
  const igualAtual = nova.length > 0 && nova === senhaAtual;
  const podeSalvar = senhaAtual && nova.length >= 6 && nova === confirma && !igualAtual;

  const salvar = async () => {
    if (!podeSalvar || salvando) return;
    setSalvando(true); setErro('');
    try {
      await trocarSenha(senhaAtual, nova);
      /* Não navega: a flag `primeiroAcesso` vira false no contexto e a
         RotaProtegida deixa passar sozinha, pro destino que a pessoa já
         estava tentando abrir. */
    } catch (e) {
      setErro(e.response?.data?.erro || 'Não foi possível trocar a senha.');
      setSalvando(false);
    }
  };

  /* ⚠ A COMPOSIÇÃO É A MESMA DAS DUAS TELAS ANTERIORES (07/09/2026):
     mesma cena, mesma coluna, mesmo lugar. Esta é a única das três que
     sabe ser a última — então é a única que pode dizer "último passo"
     sem mentir. A tela de credencial não diz o total porque o total só
     se conhece depois do login. */
  return (
    <div className="en-cena">
      <div className="en-cx en-surge">
        <span className="en-marca">SGQ.</span>

        {/* Segunda marca acesa: esta tela SABE ser a última do caminho
            dela — mas o trilho continua sem dizer total, porque a porta
            pode vir depois e ela ainda não foi descoberta. */}
        <div className="en-trilho" aria-hidden="true">
          <i className="w" /><i className="w on" /><i className="n" />
        </div>
        {/* ⚠ "OBRIGATÓRIO" SAIU DO TOPO: ele prometia uma TRAVA que não
            existe, já que o botão do rodapé desloga. E o título mudou de
            voz — "Troque a senha antes de entrar" descreve uma obrigação
            do sistema; "Crie a sua senha" descreve o que a pessoa ganha. */}
        <div className="en-nome">Crie a sua senha.</div>

        <div className="en-fm">
          <span className="en-manter-aviso">
            Você entrou com a senha que o {usuario?.criado_por_nome || 'administrador'} definiu.
            Ela serviu uma vez — a partir de agora a senha é sua, e só você a conhece.
          </span>

          {/* ⚠ OS DOIS RÓTULOS DE SEÇÃO SAÍRAM (11/09/2026, print do dono
              do produto: "essa parte tá muito poluída"). Eram quatro
              rótulos em caixa alta espacejada empilhados — dois de seção
              e dois de campo, com o MESMO tratamento — e os de seção
              eram redundantes com os de campo logo abaixo deles.

              As duas tarefas continuam separadas pelo VÃO do
              `.en-grupo2`: proximidade é o que agrupa. */}
          <label className="en-cp">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round">
              <rect x="5.25" y="10.5" width="13.5" height="10.5" rx="2.25" />
              <path d="M 8.25 10.5 V 6.75 a 3.75 3.75 0 0 1 7.5 0 V 10.5" />
            </svg>
            <span className="en-cp-txt">
              <label htmlFor="senha-atual">A senha que o administrador mandou</label>
              <input id="senha-atual" type={verAtual ? 'text' : 'password'} value={senhaAtual}
                onChange={e => setSenhaAtual(e.target.value)} autoComplete="current-password" />
            </span>
            <button type="button" className="en-olho" tabIndex={-1}
              onClick={() => setVerAtual(v => !v)} aria-label={verAtual ? 'Ocultar a senha' : 'Mostrar a senha'}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round">
                <path d="M 3 12 c 2.25 -4.5 6 -6.75 9 -6.75 s 6.75 2.25 9 6.75 c -2.25 4.5 -6 6.75 -9 6.75 s -6.75 -2.25 -9 -6.75 z" />
                <circle cx="12" cy="12" r="3" />
                {verAtual && <line x1="3" y1="3" x2="21" y2="21" />}
              </svg>
            </button>
          </label>

          <div className="en-grupo2">
            <label className="en-cp">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round">
                <rect x="5.25" y="10.5" width="13.5" height="10.5" rx="2.25" />
                <path d="M 8.25 10.5 V 6.75 a 3.75 3.75 0 0 1 7.5 0 V 10.5" />
              </svg>
              <span className="en-cp-txt">
                <label htmlFor="nova">A sua nova senha</label>
                <input id="nova" type={verNova ? 'text' : 'password'} value={nova}
                  onChange={e => setNova(e.target.value)} autoComplete="new-password" />
              </span>
              <button type="button" className="en-olho" tabIndex={-1}
                onClick={() => setVerNova(v => !v)} aria-label={verNova ? 'Ocultar a senha' : 'Mostrar a senha'}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M 3 12 c 2.25 -4.5 6 -6.75 9 -6.75 s 6.75 2.25 9 6.75 c -2.25 4.5 -6 6.75 -9 6.75 s -6.75 -2.25 -9 -6.75 z" />
                  <circle cx="12" cy="12" r="3" />
                  {verNova && <line x1="3" y1="3" x2="21" y2="21" />}
                </svg>
              </button>
            </label>

            {/* A barra mede o que o backend COBRA — comprimento — e não
                inventa regra que o servidor não aplica. Quatro traços em
                6, 8, 10 e 12 caracteres. */}
            {/* ⚠ A BARRA SÓ NASCE QUANDO HÁ O QUE MEDIR (11/09/2026).
                Vazia, antes de digitar, com "Pelo menos 6 caracteres"
                embaixo, ela era REGRA VESTIDA DE MEDIÇÃO — e uma
                fingindo a outra ensina a pessoa a ignorar as duas.
                Com o campo vazio quem fala é só o texto. */}
            <span className="en-forca" aria-hidden="true">
              {nova.length > 0 && (<>
                <i className={nova.length >= 6 ? 'on' : ''} />
                <i className={nova.length >= 8 ? 'on' : ''} />
                <i className={nova.length >= 10 ? 'on' : ''} />
                <i className={nova.length >= 12 ? 'on' : ''} />
              </>)}
            </span>
            {/* ⚠ O RÓTULO DIZ O ESTADO DE CADA CRITÉRIO, e não uma nota.
                Cumprido o comprimento, ele passa a cobrar o segundo
                critério — que é o que o servidor de fato exige além do
                tamanho. */}
            <span className="en-forca-txt">
              {nova.length === 0 ? 'Pelo menos 6 caracteres'
                : curta ? `Faltam ${6 - nova.length} caracteres`
                : igualAtual ? 'Esta é a senha que você já tem — escolha outra'
                : `${nova.length} caracteres · diferente da atual`}
            </span>

            <label className="en-cp">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round">
                <rect x="5.25" y="10.5" width="13.5" height="10.5" rx="2.25" />
                <path d="M 8.25 10.5 V 6.75 a 3.75 3.75 0 0 1 7.5 0 V 10.5" />
              </svg>
              <span className="en-cp-txt">
                <label htmlFor="confirma">Repetir a nova senha</label>
                <input id="confirma" type={verConfirma ? 'text' : 'password'} value={confirma}
                  onChange={e => setConfirma(e.target.value)} autoComplete="new-password" />
              </span>
              <button type="button" className="en-olho" tabIndex={-1}
                onClick={() => setVerConfirma(v => !v)} aria-label={verConfirma ? 'Ocultar a senha' : 'Mostrar a senha'}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M 3 12 c 2.25 -4.5 6 -6.75 9 -6.75 s 6.75 2.25 9 6.75 c -2.25 4.5 -6 6.75 -9 6.75 s -6.75 -2.25 -9 -6.75 z" />
                  <circle cx="12" cy="12" r="3" />
                  {verConfirma && <line x1="3" y1="3" x2="21" y2="21" />}
                </svg>
              </button>
            </label>
          </div>

          {(erro || diferentes || igualAtual) && (
            <div className="en-recado erro">
              {erro || (igualAtual ? 'A nova senha não pode ser a mesma que a atual.'
                : 'As duas senhas não conferem.')}
            </div>
          )}

          <button type="button" className="en-bt" disabled={!podeSalvar || salvando} onClick={salvar}>
            {salvando ? (<><span className="en-spinner" />Salvando...</>) : 'Salvar e entrar'}
          </button>

          {/* ⚠ O RÓTULO DIZ O QUE O BOTÃO FAZ. Era "Sair sem trocar", e o
              topo dizia "obrigatório" — o usuário lia uma obrigação e uma
              saída, e concluía que dava para PULAR a etapa. Não dá: o
              botão desloga. Sair daqui continua legítimo, pela razão
              original: quem abriu a tela por engano não pode ficar preso
              nela. */}
          <button type="button" className="en-outro" onClick={logout}>
            Sair do sistema
          </button>
        </div>

        <div className="en-pe">
          <span>SGQ. SOLLOS.</span>
          <span className="en-ano">Uso interno {new Date().getFullYear()}</span>
        </div>
      </div>

      {/* A MESMA foto do Login, com as duas versões — ver a nota do
          import. O `.en-foto` já resolve qual usar por tamanho de tela. */}
      <div className="en-foto" style={{
        '--foto-pc': `url(${fotoGabaritos})`,
        '--foto-cel': `url(${fotoPredio})`
      }}>
        <div className="en-slogan">
          Cada processo registrado.<br />
          Cada pedido rastreado.<br />
          Cada decisão documentada.
        </div>
      </div>
    </div>
  );
}
